export default (context, inject) => {
  inject('careerLevel', {
    getContent: function(careerLevelCode) {
      return careerLevels[careerLevelCode]
    }
  })
}

const careerLevels = {
  M5: {
    code: 'M5',
    title: 'career-levels.M5.title',
    descriptions: [
      'career-levels.M5.description1',
      'career-levels.M5.description2',
      'career-levels.M5.description3',
      'career-levels.M5.description4',
      'career-levels.M5.description5'
    ],
    differentiators: []
  },
  M4: {
    code: 'M4',
    title: 'career-levels.M4.title',
    descriptions: [
      'career-levels.M4.description1',
      'career-levels.M4.description2',
      'career-levels.M4.description3',
      'career-levels.M4.description4'
    ],
    differentiators: []
  },
  M3: {
    code: 'M3',
    title: 'career-levels.M3.title',
    descriptions: [
      'career-levels.M3.description1',
      'career-levels.M3.description2',
      'career-levels.M3.description3',
      'career-levels.M3.description4',
      'career-levels.M3.description5'
    ],
    differentiators: [
      {
        title: 'career-levels.M3.differentiators.G15.title',
        descriptions: [
          'career-levels.M3.differentiators.G15.description1',
          'career-levels.M3.differentiators.G15.description2',
          'career-levels.M3.differentiators.G15.description3',
          'career-levels.M3.differentiators.G15.description4',
          'career-levels.M3.differentiators.G15.description5'
        ]
      },
      {
        title: 'career-levels.M3.differentiators.G14.title',
        descriptions: [
          'career-levels.M3.differentiators.G14.description1',
          'career-levels.M3.differentiators.G14.description2',
          'career-levels.M3.differentiators.G14.description3'
        ]
      }
    ]
  },
  M2: {
    code: 'M2',
    title: 'career-levels.M2.title',
    descriptions: [
      'career-levels.M2.description1',
      'career-levels.M2.description2',
      'career-levels.M2.description3',
      'career-levels.M2.description4',
      'career-levels.M2.description5'
    ],
    differentiators: [
      {
        title: 'career-levels.M2.differentiators.G13.title',
        descriptions: [
          'career-levels.M2.differentiators.G13.description1',
          'career-levels.M2.differentiators.G13.description2',
          'career-levels.M2.differentiators.G13.description3'
        ]
      },
      {
        title: 'career-levels.M2.differentiators.G12.title',
        descriptions: [
          'career-levels.M2.differentiators.G12.description1',
          'career-levels.M2.differentiators.G12.description2',
          'career-levels.M2.differentiators.G12.description3'
        ]
      }
    ]
  },
  M1: {
    code: 'M1',
    title: 'career-levels.M1.title',
    descriptions: [
      'career-levels.M1.description1',
      'career-levels.M1.description2',
      'career-levels.M1.description3',
      'career-levels.M1.description4'
    ],
    differentiators: [
      {
        title: 'career-levels.M1.differentiators.G11.title',
        descriptions: [
          'career-levels.M1.differentiators.G11.description1',
          'career-levels.M1.differentiators.G11.description2',
          'career-levels.M1.differentiators.G11.description3',
          'career-levels.M1.differentiators.G11.description4'
        ]
      },
      {
        title: 'career-levels.M1.differentiators.G10.title',
        descriptions: [
          'career-levels.M1.differentiators.G10.description1',
          'career-levels.M1.differentiators.G10.description2',
          'career-levels.M1.differentiators.G10.description3'
        ]
      }
    ]
  },
  P6: {
    code: 'P6',
    title: 'career-levels.P6.title',
    descriptions: [
      'career-levels.P6.description1',
      'career-levels.P6.description2',
      'career-levels.P6.description3',
      'career-levels.P6.description4',
      'career-levels.P6.description5',
      'career-levels.P6.description6'
    ],
    differentiators: [
      {
        title: 'career-levels.P6.differentiators.G17.title',
        descriptions: [
          'career-levels.P6.differentiators.G17.description1',
          'career-levels.P6.differentiators.G17.description2',
          'career-levels.P6.differentiators.G17.description3'
        ]
      },
      {
        title: 'career-levels.P6.differentiators.G16.title',
        descriptions: [
          'career-levels.P6.differentiators.G16.description1',
          'career-levels.P6.differentiators.G16.description2',
          'career-levels.P6.differentiators.G16.description3'
        ]
      }
    ]
  },
  P5: {
    code: 'P5',
    title: 'career-levels.P5.title',
    descriptions: [
      'career-levels.P5.description1',
      'career-levels.P5.description2',
      'career-levels.P5.description3',
      'career-levels.P5.description4',
      'career-levels.P5.description5',
      'career-levels.P5.description6',
      'career-levels.P5.description7'
    ],
    differentiators: []
  },
  P4: {
    code: 'P4',
    title: 'career-levels.P4.title',
    descriptions: [
      'career-levels.P4.description1',
      'career-levels.P4.description2',
      'career-levels.P4.description3',
      'career-levels.P4.description4',
      'career-levels.P4.description5',
      'career-levels.P4.description6',
      'career-levels.P4.description7'
    ],
    differentiators: [
      {
        title: 'career-levels.P4.differentiators.G14.title',
        descriptions: [
          'career-levels.P4.differentiators.G14.description1',
          'career-levels.P4.differentiators.G14.description2',
          'career-levels.P4.differentiators.G14.description3',
          'career-levels.P4.differentiators.G14.description4'
        ]
      },
      {
        title: 'career-levels.P4.differentiators.G13.title',
        descriptions: [
          'career-levels.P4.differentiators.G13.description1',
          'career-levels.P4.differentiators.G13.description2',
          'career-levels.P4.differentiators.G13.description3',
          'career-levels.P4.differentiators.G13.description4'
        ]
      }
    ]
  },
  P3: {
    code: 'P3',
    title: 'career-levels.P3.title',
    descriptions: [
      'career-levels.P3.description1',
      'career-levels.P3.description2',
      'career-levels.P3.description3',
      'career-levels.P3.description4',
      'career-levels.P3.description5',
      'career-levels.P3.description6'
    ],
    differentiators: [
      {
        title: 'career-levels.P3.differentiators.G12.title',
        descriptions: [
          'career-levels.P3.differentiators.G12.description1',
          'career-levels.P3.differentiators.G12.description2',
          'career-levels.P3.differentiators.G12.description3',
          'career-levels.P3.differentiators.G12.description4'
        ]
      },
      {
        title: 'career-levels.P3.differentiators.G11.title',
        descriptions: [
          'career-levels.P3.differentiators.G11.description1',
          'career-levels.P3.differentiators.G11.description2',
          'career-levels.P3.differentiators.G11.description3',
          'career-levels.P3.differentiators.G11.description4'
        ]
      }
    ]
  },
  P2: {
    code: 'P2',
    title: 'career-levels.P2.title',
    descriptions: [
      'career-levels.P2.description1',
      'career-levels.P2.description2',
      'career-levels.P2.description3',
      'career-levels.P2.description4',
      'career-levels.P2.description5'
    ],
    differentiators: [
      {
        title: 'career-levels.P2.differentiators.G10.title',
        descriptions: [
          'career-levels.P2.differentiators.G10.description1',
          'career-levels.P2.differentiators.G10.description2',
          'career-levels.P2.differentiators.G10.description3',
          'career-levels.P2.differentiators.G10.description4'
        ]
      },
      {
        title: 'career-levels.P2.differentiators.G09.title',
        descriptions: [
          'career-levels.P2.differentiators.G09.description1',
          'career-levels.P2.differentiators.G09.description2',
          'career-levels.P2.differentiators.G09.description3',
          'career-levels.P2.differentiators.G09.description4'
        ]
      }
    ]
  },
  P1: {
    code: 'P1',
    title: 'career-levels.P1.title',
    descriptions: [
      'career-levels.P1.description1',
      'career-levels.P1.description2',
      'career-levels.P1.description3',
      'career-levels.P1.description4',
      'career-levels.P1.description5'
    ],
    differentiators: []
  }
}
